import type { Repository } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { PageContent } from "~/components/PageContent/PageContent";
interface PhBranchDeploymentProcessPageProps {
    loaderData: LoaderData;
}
interface PhBranchDeploymentProcessPageQueryParams {
    newlyCreatedProject?: boolean;
    configureProject?: boolean;
    loadSampleProcess?: string;
}
interface LoaderData {
}
export async function phBranchDeploymentProcessPageLoader(repository: Repository, { routeParams, queryParams }: {
    routeParams: {
        slug: string;
        gitRef: string;
    };
    queryParams: PhBranchDeploymentProcessPageQueryParams;
}): Promise<LoaderData> {
    // TODO: Implement proper loader
    return {};
}
export function PhBranchDeploymentProcessPage({ loaderData }: PhBranchDeploymentProcessPageProps) {
    return (<PageContent header={{ title: "Project Template Deployment Process" }}>
            <div>
                <h1>Project Template Deployment Process</h1>
                <p>This page is a placeholder for the project template deployment process page.</p>
            </div>
        </PageContent>);
}
